function extractDateFromString (inputString) {
  // Match the date portion in the format 'YYYY-MM-DD'
  const match = inputString.match(/\d{4}-\d{2}-\d{2}/)

  // If a match is found, return the matched date portion
  return match ? match[0] : null
}

export default extractDateFromString
